import { rem } from 'polished'
import IconClose from '../../../vectors/IconClose'
import styled, { withTheme } from 'styled-components'

const IconCloseClear = styled(IconClose)`
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: ${rem(15)};
  width: ${rem(14)};
  path {
    transition: fill 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  }
  &:hover > path {
    fill: rgba(66, 76, 94, 1);
  }
`
IconCloseClear.displayName = 'IconCloseClear'

export default withTheme(IconCloseClear)
